module.exports = __webpack_public_path__ + "static/img/1.b119dec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/1.png
// module id = ucnC
// module chunks = 0